import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Nav from './components/Nav';
import Landing from './components/Landing';
import "./styles/main.scss"

function App() {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        document.documentElement.lang = i18n.language;
        document.title = t('documentTitle');
    }, [i18n.language, t]);

    return (
        <div className="app" id="top">
            <Nav />
            <Landing />
        </div>
    );
}

export default App;
